import React, { Component } from 'react';
import '../../inc/genstyle.css';
import '../../inc/popup.css';
import Popup from '../../inc/popup';
import ZTELogDetail from './ipopzte-log-detail';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import DescriptionIcon from '@mui/icons-material/Description';
import SearchIcon from '@mui/icons-material/Search';
import DateTimeFormats from '../../inc/date-time-format';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[30];
 
function convertData(dataSend) {
  return new Promise((resolve, reject) => {
    var arrDetailInfo = [];
    dataSend.sort((a, b) => b.createdate._seconds - a.createdate._seconds)
    dataSend.forEach((datalog) => {
      var type_action = datalog.content.type; if(type_action === undefined) { type_action = ""; }
      var file_id = "", domain_name = "", po_number = "";
      var detail_info_request = {}, detail_info_response = {};
      if(datalog.content.request.preProvisionedDevice !== undefined) {
        if(datalog.content.request.preProvisionedDevice.fileid !== undefined) {
          file_id = datalog.content.request.preProvisionedDevice.fileid;
        }
        if(datalog.content.request.preProvisionedDevice.domain !== undefined) {
          domain_name = datalog.content.request.preProvisionedDevice.domain;
        }
        if(datalog.content.request.preProvisionedDevice.po_number !== undefined) {
          po_number = datalog.content.request.preProvisionedDevice.po_number;
        }
        detail_info_request = datalog.content.request.preProvisionedDevice;
        
      } else if(datalog.content.request !== undefined) {
        if(datalog.content.request.fileid !== undefined) {
          file_id = datalog.content.request.fileid;
        }
        if(datalog.content.request.domain !== undefined) {
          domain_name = datalog.content.request.domain;
        }
        if(datalog.content.request.po_number !== undefined) {
          po_number = datalog.content.request.po_number;
        }
        detail_info_request = datalog.content.request;
      } 
      
      if(datalog.content.response.responses !== undefined) {
        detail_info_response = datalog.content.response.responses;
      } else if(datalog.content.response.error !== undefined) {
        detail_info_response = datalog.content.response;
      } else if(datalog.content.response !== undefined) {
        detail_info_response = datalog.content.response;
      }

      var adddetail = true;
      if(arrDetailInfo.length > 0) {
        for(var x=0; x<arrDetailInfo.length; x++) {
          if(
              (po_number !== "" && po_number !== undefined && po_number === arrDetailInfo[x].ponumber) && 
              (domain_name !== "" && domain_name !== undefined && domain_name === arrDetailInfo[x].domainnam) &&
              (arrDetailInfo[x].actiontype === type_action)
            ) {
                arrDetailInfo[x].detail_request.push(detail_info_request);
                adddetail = false;
                break;

          } else if(
              (domain_name !== "" && domain_name !== undefined && domain_name === arrDetailInfo[x].domainname) && 
              (file_id !== undefined && file_id === arrDetailInfo[x].fileid) && 
              (arrDetailInfo[x].actiontype === type_action)
            ) {
                arrDetailInfo[x].detail_request.push(detail_info_request);
                adddetail = false;
                break;
          }
        }
      }
      if(adddetail === true) {
        var arrDetailResponse = [];
        if(detail_info_response.length > 0) {
          detail_info_response.forEach((res2) => {
            arrDetailResponse.push(res2);
          })
        } else {
          arrDetailResponse.push(detail_info_response);
        }  
        
        arrDetailInfo.push({
          docid: datalog.docid,
          createdate: datalog.content.createDate,
          createby: datalog.content.createByName,
          fileid : file_id,
          domainname : domain_name,
          ponumber : po_number,
          actiontype : type_action,
          detail_request: [detail_info_request],
          detail_response: arrDetailResponse,
        })
        
      } else {
        if(detail_info_response.length > 0) {
          detail_info_response.forEach((res) => {
            arrDetailInfo[x].detail_response.push(res);
          })
        } else {
          arrDetailInfo[x].detail_response.push(detail_info_response);
        }
      }
    })
    resolve(arrDetailInfo);
  })
}

class IZTElog extends Component {
  constructor(props) {
    super(props);
    this.state = {
        stTitle: '',
        pageShow: '10',
        keyword: '',
        styleTb: 'table',
        data: [],
        data_all: [],
        isOpen: false,
        otherContent: '', 
        selectSearchType: '',
        keyword: ''
    };
    this.loadData = this.loadData.bind(this);
  }
  togglePopClose() {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: false,
      }
    })
  }
  handleUserSelect = (e) => {
    this.setState({ 
      [e.target.name] : e.target.value,
      keyword: '',
      data: this.state.data_all
    });
  }

  handleChange = (e) => {
    const value = e.target.value;
    const inputname = e.target.name;
    var resultData = this.state.data_all;
    if(value !== "") {
      if(this.state.selectSearchType === "Domain Name") {
        resultData = this.state.data_all.filter((list) =>  {
          return (list.domainname?.toLowerCase().includes(value.toLowerCase()));
        });
      } else if(this.state.selectSearchType === "PO Number") {
        resultData = this.state.data_all.filter((list) =>  {
          return (list.ponumber?.toLowerCase().includes(value.toLowerCase()));
        });
      } else if(this.state.selectSearchType === "Serial Number") {
        var returnData = [];
        this.state.data_all.forEach((list) => {
          var detResponse = list.detail_response.filter((item) =>  {
            return (item.preProvisionedDevice?.serialNumber?.toLowerCase().includes(value.toLowerCase()) || item?.serialNumber?.toLowerCase().includes(value.toLowerCase()));
          });
          if(detResponse.length > 0) {
            returnData.push(list);
          }
        })
        resultData = returnData;
      }
    }

    
    this.setState({ 
        keyword : value,
        data: resultData
    })
    
  }
  urlviewDetail(valId,content) {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: true,
          ...prevState.otherContent, otherContent: content
      }
    })
  }
  urlOpenFile(fileid) {
    var urlfile = 'https://docs.google.com/spreadsheets/d/'+fileid;
    window.open(urlfile);
  }
  loadData(state,value) {
    document.getElementById('loading-area').style.display = 'block'; 
    var datatext ='{"keyword":"'+this.state.keyword+'","pageShow":"'+this.state.pageShow+'","fromset":"ztelog"}';
    var data = JSON.parse(datatext); 
    fetch(global.config.urlLink+"/zteloglist", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(response => {
        if(response.status === 200) {
            return response.json()
        } else {
            console.log('Something happened wrong');
        }
    }).then(resJson => {
        document.getElementById('loading-area').style.display = 'none'; 
        if(resJson.status === '200' && resJson.values.length > 0) { 
          convertData(resJson.values)
          .then((results) => {
      
            var arrSortByDesc = results.sort((a, b) => b.createdate._seconds - a.createdate._seconds)
            this.setState({
                styleTb: 'table table-striped',
                data: arrSortByDesc,
                data_all: arrSortByDesc,
                isOpen: false,
                otherContent: '',
                selectSearchType: 'Serial Number',
            })
          })
          
        } else {
            this.setState({
                styleTb: 'table',
                data: [],
                isOpen: false,
                otherContent: '',
            })
        } 
    }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  
  componentDidMount() {
    this.loadData();
  }
  contentTableList() {
    var logZteList = [];
    if(this.state.data.length > 0) {
      for(var ls=0; ls < this.state.data.length; ls++) {
          var retResult = this.state.data[ls];
          var sendResult = {
            dataSend : retResult,
            keyword: (this.state.selectSearchType === "Serial Number")? this.state.keyword : ''
          }
          var cDatez="", domainName="", fileId="";
          if(retResult.createdate !== undefined) {
                cDatez = DateTimeFormats(retResult.createdate._seconds,"datetime-short");
          }
          logZteList.push(<tr key={ls+1}>
              <th scope="row-field">{ls+1}</th>
              <td>{cDatez}<br/>by. {retResult.createby}</td>
              <td>{retResult.domainname}</td>
              <td>{retResult.ponumber}</td>
              <td>{retResult.actiontype}</td>
              <td>
                  <DescriptionIcon className="iconGrey mgR20 cursor-on" onClick={this.urlviewDetail.bind(this, retResult.docid, JSON.stringify(sendResult))}/>
              </td>
            </tr>)
      }
    } else {
          logZteList.push(<tr key="0">
            <td colSpan="6" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
          </tr>)
    }
    return logZteList;
  }
  
  render() {
   return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
                <div className="stTitle">Log ZTE Request</div>
                <div className="stIndiTitle">List of log request ZTE</div>
                <div className="mgT30">
                    {/*--*/}
                    <div className="content-container card card-body">
                        <div className="flex-container mgT20 ">
                            <div className="flex-container w70p">
                                    <select name="selectSearchType" className="form-control mr-sm-2"
                                            value={this.state.selectSearchType} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputSearchType = input}
                                        >
                                        <option value="Domain Name">Domain Name</option>
                                        <option value="PO Number">PO Number</option>
                                        <option value="Serial Number">Serial Number</option>
                                    </select>
                                   
                                    <input type="text" className="form-control mr-sm-2" 
                                        name="keyword" id="keyword"
                                        placeholder={`input ${this.state.selectSearchType.toLowerCase()}`} 
                                        value={this.state.keyword}
                                        onChange={this.handleChange.bind(this)}
                                        ref={(input) => this.textInputKeyword = input}
                                    />
                                    <SearchIcon style={{ fontSize: 35 }} className="iconGrey mgT05 cursor-on" onClick={this.handleChange.bind(this)}></SearchIcon> 
                                      
                            </div>
                            
                        </div>
                        <div className="row-field mgT20">
                            <table className={this.state.styleTb}>
                            <thead>
                                <tr>
                                <th scope="col">#</th>
                                <th scope="col">Requested</th>
                                <th scope="col">Domain Name</th>
                                <th scope="col">PO Number</th>
                                <th scope="col">Type</th>
                                <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.contentTableList()}
                            </tbody>
                            </table>
                        </div>
                        <div className="row mt-3">
                           
                        </div>
                    </div>
                    <div>
                        {this.state.isOpen && <Popup
                        content={<><ZTELogDetail/></>}
                        id={localStorage.getItem('uid')} 
                        title={"Log ZTE Detail"}
                        others={this.state.otherContent}
                        styles={"80%"}
                        handleClose={this.togglePopClose.bind(this, localStorage.getItem('uid'))}
                        />}
                    </div>
                    {/*--*/}
                </div>
              </div>
              
          </div>
          <div id="loading-area" className="divHide loading"></div> 
    </div>
   );
 }
}
 
export default IZTElog;